var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"viewBox":"0 0 1024 1024","width":_vm.size,"height":_vm.size}},[_c('path',{attrs:{"d":"M127.389 851.634l724.21-724.21 45.198 45.196-724.211 724.212z","p-id":"11226"}})])}
var staticRenderFns = []

export { render, staticRenderFns }